import { Icon } from '@eventbrite/eds-icon';
import { MapPinFill } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    EventDetail,
    EventDetailContent,
    EventDetailHeading,
    EventDetailIcon,
    ICON_COLOR,
    ICON_SIZE,
} from '../EventDetail/EventDetail';

export type LocationProps = {
    hasAddress?: boolean;
    hasMap?: boolean;
    venueMultilineAddress?: string[];
    venueName?: string;
    isOnlineEvent: boolean;
    onlineEventUrl?: string;
};

export const Location = ({
    isOnlineEvent,
    onlineEventUrl,
    hasAddress,
    hasMap,
    venueMultilineAddress,
    venueName,
}: LocationProps) => {
    if (!hasAddress && !isOnlineEvent) {
        return null;
    }

    const OnlineEvent = () => {
        return (
            <>
                {
                    <p className="eds-text-weight--heavy">
                        {gettext('Online event')}
                    </p>
                }
                {onlineEventUrl && (
                    <>
                        <p className="eds-l-mar-top-1 eds-l-mar-bot-3">
                            {gettext('Already have a ticket?')}
                        </p>
                        <a
                            className="eds-btn eds-btn--button eds-btn--neutral"
                            href={onlineEventUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {gettext('Access the event')}
                        </a>
                    </>
                )}
            </>
        );
    };

    const InPersonEvent = () => {
        return (
            <>
                {venueName && <p>{venueName}</p>}
                {venueMultilineAddress?.map((line, index) => (
                    <p key={index}>{line}</p>
                ))}
                {hasMap && (
                    <p>
                        <a
                            className="js-d-scroll-to js-scroll-to-map"
                            href="#listings-root__event-location-map"
                            data-d-duration="1500"
                            data-d-destination="#listings-root__event-location-map"
                        >
                            {gettext('View map')}
                        </a>
                    </p>
                )}
            </>
        );
    };

    const LABEL_ID = 'location-heading';

    return (
        <EventDetail ariaLabelledBy={LABEL_ID}>
            <EventDetailIcon>
                <Icon
                    type={<MapPinFill />}
                    size={ICON_SIZE}
                    color={ICON_COLOR}
                />
            </EventDetailIcon>
            <EventDetailContent>
                <EventDetailHeading>
                    <h3 id={LABEL_ID}>{gettext('Location')}</h3>
                </EventDetailHeading>
                {isOnlineEvent && <OnlineEvent />}
                {hasAddress && <InPersonEvent />}
            </EventDetailContent>
        </EventDetail>
    );
};
